import { h } from 'preact'
import Pagination from '../pagination/Pagination'

export interface PaginationProps {
    page?: number,
    pageSize?: number,
    total?: number
}

interface PaginationComponentProps {
  pagination?: PaginationProps,
  onPageChange?: (page: number) => void,
  onPageSizeChange?: (pageSize: number) => void,
  displayListUpwards?: boolean
}

const PaginationComponent = ({ pagination, onPageChange, onPageSizeChange, displayListUpwards }: PaginationComponentProps) => (
  <Pagination
    displayListUpwards={displayListUpwards}
    currentPage={pagination?.page}
    total={pagination?.total}
    pageSize={pagination?.pageSize}
    pageSizes={[10, 25, 50]}
    onPageChange={(page: number) => onPageChange && onPageChange(page)}
    onPageSizeChange={(pageSize: number) => onPageSizeChange && onPageSizeChange(pageSize)}
  />
)

export default PaginationComponent
